// ============================================================================
// « AUCUN GROUPE » — les appareils d'un magasin ne suivent PAS le store privé pour une application : ils se mettent à
// jour par leur propre store (celui du fabricant de l'équipement).
//
// UTILITÉ : certains équipements ne passent que par leur store, et on ne peut pas les forcer sur le nôtre (décision
// utilisateur). La Console le choisit, par magasin et par application, à côté du flux public et des groupes ; les
// appareils le reçoivent là où ils reçoivent un groupe — le réglage `update.group_ref` pour la caisse, la réponse
// d'appairage et le tirage de configuration pour Mobile Partner.
//
// ⚠️ UNE VALEUR QU'AUCUN JETON NE PEUT PRENDRE : un jeton d'inscription est du base64url (lettres, chiffres, « - »,
//    « _ ») ; « @ » n'en fait pas partie. Elle voyage À LA PLACE du jeton, dans la même clé : deux clés pourraient dire
//    « aucun » et « tel groupe » à la fois, une seule ne le peut pas.
// ⚠️ PERSISTÉE (Console) ET DESCENDUE AUX APPAREILS : elle se migre, elle ne se renomme jamais.
// ============================================================================

/** Le choix « aucun groupe » : ni le flux public ni un groupe — les mises à jour viennent du store de l'appareil. */
export const NO_PRIVATE_STORE_UPDATES = '@none';

/** Ce choix de groupe dit-il « ne pas suivre le store privé » ? */
export const followsNoPrivateStore = (ref: string | null | undefined): boolean => (ref ?? '').trim() === NO_PRIVATE_STORE_UPDATES;
